export const reactData = [
  {
    question: "What is React?",
    answer: "React is a JavaScript library for building user interfaces.",
  },
  {
    question: "React",
    answer: "React is a JavaScript library for building user interfaces.",
  },
  {
    question: "Who developed React?",
    answer: "React was developed by Facebook.",
  },
  {
    question: "When was React first released?",
    answer: "React was first released in March 2013.",
  },
  {
    question: "What is JSX?",
    answer: "JSX is a syntax extension for JavaScript used with React to describe what the UI should look like.",
    followUp: "Why is JSX used in React?",
    followUpAnswer: "JSX allows developers to write HTML-like code directly in their JavaScript files, making it easier to visualize and work with the UI components.",
  },
  {
    question: "What are the key features of React?",
    answer: "Key features of React include component-based architecture, virtual DOM, JSX, and one-way data binding.",
  },
  {
    question: "What is a component in React?",
    answer: "A component in React is a reusable piece of UI that can contain its own logic and state.",
    followUp: "What are the types of components in React?",
    followUpAnswer: "There are two types of components in React: functional components and class components.",
  },
  {
    question: "What is the Virtual DOM?",
    answer: "The Virtual DOM is a lightweight copy of the real DOM in memory that React uses to perform updates efficiently.",
    followUp: "Why is the Virtual DOM important?",
    followUpAnswer: "The Virtual DOM allows React to update only the necessary parts of the actual DOM, resulting in improved performance and a better user experience.",
  },
  {
    question: "What is state in React?",
    answer: "State in React is an object that represents the current state of a component, which can change over time.",
    followUp: "How is state different from props?",
    followUpAnswer: "State is managed within a component and can be changed by the component itself, while props are passed down from parent components and are immutable.",
  },
  // Add more question-answer pairs here...
];
